export const ADD_NEW_COMPANY = `
  mutation (
    $name: String!,
    $email: String!,
    $mobile: String,
    $address: String,
    $gst_number: String
  ) {
    add_new_company(
      name: $name,
      email: $email,
      mobile: $mobile,
      address: $address,
      gst_number: $gst_number
    ) {
      message
      _id
    }
  }
`;


export const UPDATE_COMPANY = `
  mutation (
    $_id: String!,
    $name: String,
    $email: String,
    $address: String,
    $gst_number: String,
    $mobile: String,
    $is_active: Boolean
  ) {
    update_company(
      _id: $_id,
      name: $name,
      email: $email,
      address: $address,
      gst_number: $gst_number,
      mobile: $mobile,
      is_active: $is_active
    ) {
      message
      _id
    }
  }
`;

export const LIST_ALL_COMPANIES = `
  query (
    $pageSize: Int,
    $pageNumber: Int,
    $isForDropdown: Boolean
  ) {
    list_all_hotel_companies(
      page_size: $pageSize,
      page_number: $pageNumber,
      is_for_dropdown: $isForDropdown
    ) {
      message
      data {
        _id
        name
        email
        mobile
        address
        gst_number
        is_active
      }
      hasMore
    }
  }
`;
